import { FolderStarMultipleIcon } from './FolderStarMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 407F7D88-25F6-4EDF-8489-3F8B7996F704
 * name folder-star-multiple
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-star-multiple.svg
 * tags
 * - Files / Folders 
 */
export const FolderFavoriteMultipleIcon = FolderStarMultipleIcon;
export default FolderFavoriteMultipleIcon